
import angular from "angular";

import DependencyListBuilder from "../../../utility/DependencyListBuilder";

import MainPageNavbarController from "./MainPageNavbarController";

const MainPageNavbarComponent = {
    name: "tbMainPageNavbar",
    config: {
        template: MainPageNavbarController.template,
        controller: MainPageNavbarController,
        controllerAs: MainPageNavbarController.controllerAs
    },
    dependencies: DependencyListBuilder(
        MainPageNavbarController.dependencies
    )
};

export default angular
    .module(
        "trackerbase-app.views.main-page.tb-main-page-navbar",
        MainPageNavbarComponent.dependencies
    )
    .component(MainPageNavbarComponent.name, MainPageNavbarComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/main-page/MainPageNavbar/index.js
// module id = n0y/
// module chunks = 1